import {
  Alert,
  AlertTitle,
  Button,
  CardActions,
  CardContent,
  Snackbar,
  styled,
  TextField,
  Typography,
} from '@mui/material';
import React from 'react';
import { saveQrcodeFeedback } from '../../../api';

import { API_RESPONSE_STATUS_CODE } from '../../../constants/app';
import textareaIcon from '../../../assets/textarea.svg';
import {
  Field,
  type Feedback,
  type Value,
} from '../../../interfaces/qrcode-feedback.type';

type IProps = {
  goSuccess: VoidFunction;
  feedback: Feedback;
  onChange: (f: Field) => (v: Value) => void;
};

const EMPTY_ERROR = { title: '', message: '' };

function ClaimForm({ goSuccess, feedback, onChange }: IProps) {
  const [saving, setSaving] = React.useState(false);

  const [error, setError] = React.useState(EMPTY_ERROR);

  const handleSubmit = async () => {
    setSaving(true);

    saveQrcodeFeedback({ ...feedback, isSuccess: false })
      .then((result) => {
        if (result.status === API_RESPONSE_STATUS_CODE.CREATED) {
          goSuccess();
        } else {
          setError({
            title: result?.error || 'Ошибка сервера',
            message: result?.message || 'Что то пошло не так',
          });
        }
      })
      .catch()
      .finally(() => setSaving(false));
  };

  return (
    <>
      <CardContentWrap sx={{ padding: '32px 0 48px' }}>
        <Typography
          sx={{
            fontFamily: '"Nunito Sans", sans-serif',
            mb: 1,
            whiteSpace: 'pre-wrap',
            textAlign: 'start',
          }}
          fontSize={16}
          lineHeight={'24px'}
          fontWeight={600}
        >
          {'Расскажите, пожалуйста, что Вам не понравилось в нашей клинике. '}
        </Typography>

        <Typography
          sx={{
            fontFamily: '"Nunito Sans", sans-serif',
            mb: 1,
            whiteSpace: 'pre-wrap',
            textAlign: 'start',
          }}
          fontSize={16}
          lineHeight={'24px'}
          fontWeight={600}
        >
          {'Мы обязательно разберемся и предложим Вам решение проблемы.'}
        </Typography>

        <Wrapper>
          <TextField
            sx={{
              '& textarea': {
                resize: 'vertical',
                backgroundImage: `url(${textareaIcon})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: '24px',
                backgroundPosition: '100% 100%',
                overflow: 'hidden',
              },
              '& fieldset': {
                border: 'none',
              },
              '& .MuiInputLabel-root': {
                fontFamily: '"Nunito Sans", sans-serif',
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '24px',
                top: '8px',
                left: '16px',
                color: '#828282',
                transform: 'none',
              },
              '& .MuiInputLabel-root.MuiInputLabel-shrink': {
                fontSize: '11px',
                lineHeight: '16px',
                fontWeight: 600,
                transform: 'none',
                top: '8px',
                left: '16px',
                color: '#828282',
              },
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#FFFFFF',
                borderRadius: '24px',
                border: '1px solid #98B6F1',
                padding: '24px 8px 8px 16px',
              },
              '& .MuiOutlinedInput-root.Mui-focused': {
                borderColor: '#316EE5',
              },
            }}
            id='feedback'
            autoFocus
            label='Опишите ситуацию'
            multiline
            fullWidth
            rows={4}
            value={feedback.text}
            onChange={(e) => onChange(Field.Text)(e.target.value)}
          />
        </Wrapper>

        <CardActions
          disableSpacing={true}
          sx={{ display: 'grid', alignSelf: 'stretch', padding: 0 }}
        >
          <Button
            className='button success'
            variant='contained'
            size='large'
            onClick={handleSubmit}
            disabled={saving || !feedback.text}
          >
            Отправить
          </Button>
        </CardActions>
      </CardContentWrap>

      {error.title ? (
        <Snackbar
          open={!!error.title}
          onClose={() => setError(EMPTY_ERROR)}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          sx={{ minWidth: '95%' }}
        >
          <Alert
            variant='filled'
            severity='error'
            sx={{
              width: '100%',
              '.MuiAlert-message': {
                textAlign: 'start',
              },
            }}
            onClose={() => setError(EMPTY_ERROR)}
          >
            <AlertTitle>{error.title}</AlertTitle>
            {error.message}
          </Alert>
        </Snackbar>
      ) : null}
    </>
  );
}

const CardContentWrap = styled(CardContent)`
  display: flex;
  flex-direction: column;
`;

const Wrapper = styled('div')`
  align-self: stretch;
  flex: 1;
  display: grid;
  gap: 16px;
  padding: 16px 0 32px;
`;

export default ClaimForm;
